import React from 'react';
import { Redirect as RRRedirect, RedirectProps } from 'react-router-dom';

import { useCondensedQueryParameters } from 'hooks/useQueryParameters';
import { mergeLocation } from 'hooks/useNavigationHelpers';

const Redirect: React.FC<RedirectProps> = ({ to, ...redirectProps }) => {
  const params = useCondensedQueryParameters();
  to = mergeLocation(params, to);
  return <RRRedirect to={to} {...redirectProps} />;
};

export default Redirect;
